import { getUserToken, getUserId, getTokenExpires, isAuth0User } from 'services/authentication';

const getSessionUrl = ({ appUrl, loginPath }) => {
  const token = getUserToken();
  const expires = getTokenExpires();
  const userId = getUserId();

  if (isAuth0User() || !token || !userId) {
    return appUrl;
  }

  const session = btoa(JSON.stringify({ token, expires, userId, isAuth0: false }));

  return `${appUrl}${loginPath}${session}`;
};

export default getSessionUrl;
